import { Text } from "tamagui";
import { Link } from "./Link";

type To<
  ParamList extends
    ReactNavigation.RootParamList = ReactNavigation.RootParamList,
  RouteName extends keyof ParamList = keyof ParamList,
> =
  | RouteName
  | (undefined extends ParamList[RouteName]
      ? {
          screen: Extract<RouteName, string>;
          params?: ParamList[RouteName];
        }
      : {
          screen: Extract<RouteName, string>;
          params: ParamList[RouteName];
        });

export const SubtextLink = ({ to, children }: { to: To; children: string }) => {
  return (
    <Link to={to}>
      <Text
        flex={1}
        color="$muted"
        fontFamily="$subtextLabel"
        hoverStyle={{
          color: "$color",
        }}
      >
        {children}
      </Text>
    </Link>
  );
};
